/* A reading link beside the live reviews. No review or purchase state is changed. */
(() => {
  if (customElements.get('cosmic-reviews-cta')) return;
  customElements.define('cosmic-reviews-cta', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
      };
      this.setAttribute('data-sticky', '');
      this.inert = true;
      this.setAttribute('aria-hidden', 'true');
      window.addEventListener('scroll', this.schedule, { passive: true, signal });
      window.addEventListener('resize', this.schedule, { passive: true, signal });
      document.addEventListener('focusin', this.schedule, { signal });
      document.addEventListener('focusout', this.schedule, { signal });
      document.addEventListener('shopify:section:load', this.schedule, { signal });
      document.addEventListener('shopify:section:select', event => {
        if (event.detail?.sectionId === this.dataset.sectionId) { this.editorSelected = true; this.schedule(); }
      }, { signal });
      document.addEventListener('shopify:section:deselect', event => {
        if (event.detail?.sectionId === this.dataset.sectionId) { this.editorSelected = false; this.schedule(); }
      }, { signal });
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.schedule);
        this.resizeObserver.observe(document.body);
      }
      this.schedule();
    }
    update() {
      const intro = document.querySelector('#MainContent .csf-hero');
      const footer = document.querySelector('.cms-closing') || document.querySelector('.cms-footer-section');
      const focused = document.activeElement;
      const editing = focused?.matches('input,textarea,select,[contenteditable="true"]') || focused?.closest('dialog[open],[aria-modal="true"]');
      const pastIntro = intro && intro.getBoundingClientRect().bottom <= 90;
      const atFooter = footer && footer.getBoundingClientRect().top < innerHeight - 140;
      const keepFocus = this.contains(focused);
      const visible = Boolean(keepFocus || this.editorSelected || (pastIntro && !atFooter && !editing));
      this.toggleAttribute('data-visible', visible);
      this.inert = !visible;
      this.setAttribute('aria-hidden', String(!visible));
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = null;
      this.editorSelected = false;
    }
  });
})();
